import './App.css';
import NavBar from './Components/Navbar';
import Intro from './Components/Intro';
import About from './Components/About';
import Skills from './Components/Skills';
import Projects from './Components/Projects';
import Contact from './Components/Contact';
import Loading from './Components/Loading';
import {useEffect, useState} from 'react';

function App() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 1200);

    const remove = setTimeout(() => {
      setLoading(false);
    }, 1700);

    return () => {
      clearTimeout(timer);
      clearTimeout(remove);
    };
  }, []);

  return (
    <>
      {loading && <Loading fadeOut={fadeOut} />}
      {!loading && (
        <>
          <NavBar />
          <main>
            <Intro />
            <About />
            <Skills />
            <Projects />
            <Contact />
          </main>
        </>
      )}
    </>
  );
}

export default App;
